import * as React from 'react';
import { ArrowDownButton } from '../../components/ArrowDownButton';
import { STICKY_HEADER_HEIGHT } from '../../constants/elements';

export const ScrollDown = () => {
  const onClick = React.useCallback(() => {
    const scrollHeight = window.innerHeight - (STICKY_HEADER_HEIGHT - 1);
    window.scrollTo({ top: scrollHeight, behavior: 'smooth' });
  }, []);

  return <ArrowDownButton onClick={onClick} />;
};

ScrollDown.displayName = 'ScrollDown';
